import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { getGoogleOauthUrl } from "api";
import { SpinnerFullPage } from 'shared/components/SpinnerFullPage/index.js';

export function GoogleLoginInitPage () {
  const [urlSearchParams] = useSearchParams();
  useEffect(() => {
    const redirect = async () => {
      const { redirectUrl } = await getGoogleOauthUrl(Object.fromEntries(urlSearchParams.entries()));
      window.location.replace(redirectUrl);
    };
    redirect();
  }, [urlSearchParams]);

  return (
    <SpinnerFullPage />
  )
}
